<template>
  <div class="flex items-center px-3 py-4">
    <StatusTagProvider
      :id="`external_domain_status_${row?.id}`"
      source="external_domain"
      :text="badge.label"
      :color="badge.color"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import StatusTagProvider from "@/src/components/StatusTagProvider.vue";
import { statusTagProviderColors } from "@/src/constants/customComponentConstants.js";
import {
  EXTERNAL_DOMAIN_STATUS,
  STATUS_BADGE_CONFIG,
} from "@/src/constants/externalDomainsConstants.js";

const props = defineProps({
  value: { type: String, default: "" },
  row: { type: Object, default: () => ({}) },
});

const toneToColor = {
  success: statusTagProviderColors.GREEN,
  warning: statusTagProviderColors.YELLOW,
  danger: statusTagProviderColors.RED,
  neutral: statusTagProviderColors.GREY,
};

const badge = computed(() => {
  const config =
    STATUS_BADGE_CONFIG[props.value] ||
    STATUS_BADGE_CONFIG[EXTERNAL_DOMAIN_STATUS.PARKED];
  return {
    label: config.label,
    color: toneToColor[config.tone] || statusTagProviderColors.GREY,
  };
});
</script>
